const MCP_TOOL_SOURCE = 'MCP_TOOL';

/**
 * MCP tool keys are user-generated content and must not leak into analytics
 * payloads. For all other sources, including a missing toolSource, forward the
 * raw key.
 */
export const redactToolKeyForPii = ({
	toolDefinitionSource,
	key,
}: {
	toolDefinitionSource: string | undefined;
	key: string | undefined;
}): string | undefined => (toolDefinitionSource === MCP_TOOL_SOURCE ? undefined : key);
